"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/radix/tooltip";
import { SkeletonLoader } from "@/components/ui/skeleton";
import { approvalsInfo } from "@/info/approvals";
import { banksInfo } from "@/info/banks";
import { documentsInfo } from "@/info/documents";
import { SellerUnitsAndProjectsOne } from "@/types/sup";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
import { Info } from "lucide-react";
import { StringList } from "../../string-list";
import { WaterSource } from "../seller-unit/water-source";
interface ProjectData {
  propertyType?: string;
  specifications?: string;
  area?: string;
  roads?: string[];
  reraId?: string;
}
interface ProjectDetailsProps {
  supOne: SellerUnitsAndProjectsOne;
  waterSourceString?: string;
  ageString?: string;
  isProjectPage?: boolean;
  isLoading?: boolean;
  projectData?: ProjectData;
}
export function ProjectDetails(t0) {
  const $ = _c(33);
  const {
    supOne,
    waterSourceString,
    ageString,
    isProjectPage,
    isLoading: t1,
    projectData
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== supOne.propertyTypes) {
    t2 = supOne.propertyTypes?.some(_temp);
    $[0] = supOne.propertyTypes;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isPlotProperty = t2;
  let t3;
  if ($[2] !== supOne.approvals) {
    t3 = <StringList className="text-right" data={supOne.approvals} info={approvalsInfo.bengaluru} fallback="Not specified" />;
    $[2] = supOne.approvals;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] !== ageString || $[5] !== isLoading || $[6] !== isPlotProperty || $[7] !== isProjectPage || $[8] !== projectData || $[9] !== supOne.amenities || $[10] !== supOne.bankApprovals || $[11] !== supOne.documents || $[12] !== supOne.possessionStatuses || $[13] !== supOne.totalBasements || $[14] !== supOne.totalBlocks || $[15] !== supOne.totalFloors || $[16] !== supOne.totalUnits || $[17] !== supOne.waterSource || $[18] !== t3 || $[19] !== waterSourceString) {
    const projectRows = [{
      label: "Approvals",
      value: t3
    }, {
      label: "Bank Approvals",
      value: <StringList className="text-right" data={supOne.bankApprovals} info={banksInfo} fallback="Not specified" />
    }, {
      label: "Documents",
      value: <StringList className="text-right" data={supOne.documents} info={documentsInfo} fallback="Not specified" />
    }, ...(!isPlotProperty ? [{
      label: "Lifts",
      value: supOne.amenities?.includes("lift") ? "Yes" : "No"
    }] : []), ...(!isPlotProperty ? [{
      label: "Possession status",
      value: isProjectPage ? [...new Set(supOne.possessionStatuses ?? [])].map(_temp2).join(", ") + ` (${ageString})` : ""
    }] : []), {
      label: "Swimming Pool",
      value: supOne.amenities?.includes("swimmingPool") ? "Yes" : "No"
    }, {
      label: "Total Basements",
      value: supOne.totalBasements?.toString() || ""
    }, {
      label: "Total Blocks",
      value: supOne.totalBlocks?.toString() || ""
    }, {
      label: "Total Floors in the Building",
      value: supOne.totalFloors || ""
    }, {
      label: "Total Units",
      value: supOne.totalUnits?.toString() || ""
    }, {
      label: "Water Source",
      value: waterSourceString || (supOne.waterSource ? <WaterSource waterSource={supOne.waterSource} fallback="" /> : "")
    }, {
      label: "Property Type",
      value: projectData?.propertyType || ""
    }, {
      label: "Specifications",
      value: projectData?.specifications || ""
    }, {
      label: "Area",
      value: projectData?.area ? projectData.area + " Acres" : ""
    }, {
      label: "Roads",
      value: projectData?.roads?.join(", ") || ""
    }, {
      label: "RERA ID",
      value: projectData?.reraId || ""
    }].filter(_temp3);
    const sortedProjectRows = [...projectRows].sort(_temp4);
    let t7;
    if ($[23] !== isLoading) {
      t7 = (row_0, index) => <div key={index} className="flex justify-between items-center py-1.5 px-2 border-b border-gray-200"><span className="text-sm font-medium text-gray-600">{row_0.label}</span><div className="flex items-center gap-1">{row_0.available || !isLoading ? <span className="text-sm font-semibold text-primary-700">{row_0.value}</span> : <SkeletonLoader height="16px" width="30%" />}{row_0.info && <Tooltip><TooltipTrigger asChild={true}><Info className="w-3.5 h-3.5 text-primary-700 cursor-help" /></TooltipTrigger><TooltipContent>{row_0.info}</TooltipContent></Tooltip>}</div></div>;
      $[23] = isLoading;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    const renderDetailRow = t7;
    t6 = "bg-white p-2 mt-2";
    t4 = "space-y-1";
    let t8;
    if ($[25] !== renderDetailRow) {
      t8 = (row_1, index_0) => renderDetailRow(row_1, index_0);
      $[25] = renderDetailRow;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    t5 = sortedProjectRows.map(t8);
    $[4] = ageString;
    $[5] = isLoading;
    $[6] = isPlotProperty;
    $[7] = isProjectPage;
    $[8] = projectData;
    $[9] = supOne.amenities;
    $[10] = supOne.bankApprovals;
    $[11] = supOne.documents;
    $[12] = supOne.possessionStatuses;
    $[13] = supOne.totalBasements;
    $[14] = supOne.totalBlocks;
    $[15] = supOne.totalFloors;
    $[16] = supOne.totalUnits;
    $[17] = supOne.waterSource;
    $[18] = t3;
    $[19] = waterSourceString;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
  }
  let t7;
  if ($[27] !== t4 || $[28] !== t5) {
    t7 = <div className={t4}>{t5}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t6 || $[31] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
}
function _temp4(a, b) {
  return a.label.localeCompare(b.label);
}
function _temp3(row) {
  return row.value;
}
function _temp2(p) {
  return toSentenceCase(p);
}
function _temp(type) {
  return type.toLowerCase() === "plot";
}